import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

const AuthenticationPasswordStrengthBubble: React.FC = () => {
  return (
    <Tooltip
      variant="error"
      content={
        <T>
          A secure password should be at least 8 characters long, and not be a
          common term.
        </T>
      }
    />
  );
};
export default AuthenticationPasswordStrengthBubble;
